import { connect } from 'react-redux';
import { FormikErrors, withFormik } from 'formik';
import { compose } from 'lodash/fp';
import {
  convertLocationToProvisionLocationDTO,
  CreateLocationDTO,
  LocationModelWithPhoneData,
  LocationTypes,
  mockLocationWithPhoneData,
  requestCreateLocation,
} from '../../../redux/actions/location/locations';
import {
  ProvisionLocationRequestDTO,
  resetLocationCreationStatus,
} from '../../../redux/actions/location/location-status';
import { Timezones } from '../../../models/timezones';
import { selectHasWeaveAcl } from '../../../redux/actions/auth/auth.selectors';
import { Store } from '../../../redux/store/store.model';
import { CoreACLs } from '../../../redux/actions/auth/auth.types';
import { LocationForm } from '../location-form/location-form.component';
import { Template } from '@weave/schema-gen-ts/dist/schemas/phone/tenantprovisioner/tenantprovisioner_service.pb';
import { validateCallerNumber } from 'helpers/validators';

export const validateLocationExternalCreateForm = function (
  values: LocationModelWithPhoneData
) {
  const errors: FormikErrors<LocationModelWithPhoneData> = {};

  if (!values.Name) {
    errors.Name = 'Required';
  }

  // BusinessId validation - replacing SalesforceID validation
  if (!values.BusinessId) {
    errors.BusinessId = 'Business ID is required for external locations';
  }

  const callerNumberError = validateCallerNumber(values.caller_number);
  if (callerNumberError) {
    errors.caller_number = callerNumberError;
  }

  return errors;
};

export const LocationCreateExternalContainer = compose(
  connect(
    (state: Store) => ({
      creationStatus: state.locationStatus.creationStatus,
      isNew: true,
      loading: state.locationStatus.loading,
      allowSetParent: selectHasWeaveAcl(state, CoreACLs.WRITEMULTILOCATIONCONFIGS),
    }),
    (dispatch, ownProps: any) => ({
      createLocation: (
        location: ProvisionLocationRequestDTO,
        hasPhoneTenant: boolean
      ) => {
        return dispatch(requestCreateLocation(location, hasPhoneTenant));
      },
      onClose: () => ownProps.history.push('/'),
      resetLocationCreationStatus: () => dispatch(resetLocationCreationStatus()),
    })
  ),
  withFormik({
    mapPropsToValues: () => {
      const location = mockLocationWithPhoneData({
        Timezone: Timezones[0].Value,
        VerticalID: 1,
        Active: true,
        Type: LocationTypes.External,
      });
      return {
        ...location,
        createPhoneTenant: true,
        BusinessId: '',
      };
    },
    validate: validateLocationExternalCreateForm,
    handleSubmit: (values, formikBag) => {
      const provisionLocation: CreateLocationDTO = {
        ...values,
        Type: Number(values.Type),
        VerticalID: Number(values.VerticalID),
        ParentID: values.ParentID || null, //Has to be null, can't be empty string
        Slug: '', // Empty slug for external locations
      };
      const req: ProvisionLocationRequestDTO = {
        ...convertLocationToProvisionLocationDTO(provisionLocation),
        salesforceProducts: [],
        truelarkBusinessId: values.BusinessId, // Use businessId instead of salesforceAccountId
        slug: undefined, // Don't send slug for external locations
        salesforceAccountId: undefined, // Don't send salesforceAccountId for external locations
        template: values.template || Template.TEMPLATE_VOICE_AI,
      };

      (formikBag.props as any).createLocation(req, values.createPhoneTenant);
      formikBag.resetForm();
    },
  })
)(LocationForm);
